<template>
  <div class="form-custom-report">

    <div v-show="!showCustomReport" class="ibox col-40">
      <div class="ibox-title">
        Relatórios
        <div v-show="lastFetch" :title="lastFetch" class="float-right mr-3" style="cursor: pointer" @click="find(true)">
          <RefreshCcwIcon/>
        </div>
      </div>

      <div class="ibox-content">
        <div class="row">
          <div class="col-md-10">
            <input v-model="filter" class="input form-control" placeholder="Filtrar por nome">
          </div>

          <div class="col-md-2">
            <button class="btn btn-outline btn-sm float-right" @click="newCustomReport()">
              Novo relatório
            </button>
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Formato</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th>Criado por</th>
              <th>Atualizado por</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="customReport in filteredReports" :key="customReport.id">
              <td>{{ customReport.name }}</td>
              <td>{{ customReport.format }}</td>
              <td>{{ customReport.createdAt | datetime }}</td>
              <td>{{ customReport.updatedAt | datetime }}</td>
              <td>{{ customReport.createdBy }}</td>
              <td>{{ customReport.updatedBy }}</td>
              <td>
                <div class="btn-group">
                  <button class="btn btn-outline" @click="edit(customReport)">
                    Editar
                  </button>
                  <button class="btn btn-outline" @click="remove(customReport)">
                    Excluir
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>

    <CustomReportForm
      v-if="showCustomReport"
      :customReport="currentCustomReport"
      :customReportSchema="customReportSchema"
      @cancel=closeForm
      @save="save"
    />
  </div>
</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import EntityProxy from '@/models/EntityProxy'
  import CustomReportForm from './CustomReportForm'
  import { RefreshCcwIcon } from 'vue-feather-icons'
  import { mapMutations } from 'vuex'

  const customReportSchema = {
    ait: { name: 'AIT', kind: 'string' },
    cnpj: { name: 'CNPJ', kind: 'string' },
    cidade: { name: 'Cidade', kind: 'string' },
    codigo_da_cidade: { name: 'Código da cidade', kind: 'string' },
    local: { name: 'Local', kind: 'string' },
    uf: { name: 'UF', kind: 'string' },
    placa: { name: 'Placa', kind: 'string' },
    renavam: { name: 'Renavam', kind: 'string' },
    numero_processo: { name: 'Número do Processo', kind: 'string' },
    situacao: { name: 'Situação', kind: 'string' },
    descricao: { name: 'Descrição da multa', kind: 'string' },
    codigo_multa: { name: 'Código da multa', kind: 'string' },
    autuador: { name: 'Órgão Autuador', kind: 'string' },
    orgao_consultado: { name: 'Órgão Consultado', kind: 'string' },
    ocorrido_em: { name: 'Date e hora do ocorrido', kind: 'datetime', formats: ['datetime_iso', 'date_iso', 'datetime_european', 'date_european', 'time'], default_format: 'datetime_iso' },
    vencimento_em: { name: 'Data de vencimento', kind: 'date', formats: ['date_iso', 'date_european'], default_format: 'date_iso' },
    valor_cents: { name: 'Valor da multa', kind: 'cents', formats: ['currency', 'cents'], default_format: 'currency' },
    valor_pago_cents: { name: 'Valor pago', kind: 'cents', formats: ['currency', 'cents'], default_format: 'currency' },
    status: { name: 'Código do status', kind: 'integer' },
    status_name: { name: 'Status da Infração', kind: 'string' },
    created_at: { name: 'Data de inclusão', kind: 'datetime', formats: ['datetime_iso', 'date_iso', 'datetime_european', 'date_european', 'time'], default_format: 'datetime_iso' },
    updated_at: { name: 'Data da última atualização', kind: 'datetime', formats: ['datetime_iso', 'date_iso', 'datetime_european', 'date_european', 'time'], default_format: 'datetime_iso' },
    'boleto.valor_cents': { name: 'Valor do boleto', kind: 'cents', formats: ['currency', 'cents'], default_format: 'currency' },
    'boleto.vencimento_em': { name: 'Data de vencimento do boleto', kind: 'date', formats: ['date_iso', 'date_european'], default_format: 'date_iso' },
    'boleto.codigo_de_barra': { name: 'Código de barra do boleto', kind: 'string' },
    'boleto.nosso_numero_boleto': { name: 'Nosso Número do Boleto', kind: 'string' },
    'company.code': { name: 'Código da empresa', kind: 'string' },
    'company.name': { name: 'Razão Social', kind: 'string' },
    'company.cnpj': { name: 'CNPJ da empresa', kind: 'string' },
    company_status: { name: 'Status da Empresa', kind: 'string' },
  }

  export default {
    components: { CustomReportForm, RefreshCcwIcon },
    computed: {
      currentAxios() {
        return this.axios.v3
      },
      filteredReports() {
        if (!this.filter) return this.customReports
        const searchTerm = this.filter.toLowerCase()
        return this.customReports.filter(report => 
          report.name.toLowerCase().includes(searchTerm)
        )
      }
    },
    created() {
      this.find()
    },
    data() {
      return {
        customReports: [],
        showCustomReport: false,
        currentCustomReport: {},
        lastFetch: null,
        customReportSchema: customReportSchema,
        filter: '',
        nameModel: 'CustomReport',
      }
    },
    methods: {
      ...mapMutations(['setNameBreadcrumb']),
      find(forceLoad) {
        const customReports = this.$ls.get('cm-embarcador/custom-reports')
        if (!forceLoad && customReports) {
          this.customReports = EntityProxy.build(customReports)
          this.lastFetch = this.$ls.get('cm-embarcador/custom-reports-last-fetch')
          return
        }

        this.openLoad()
        this.axios.v3.get('custom_reports')
          .then(response => { 
            this.customReports = EntityProxy.build(response.data)
            this.$ls.set('cm-embarcador/custom-reports', this.customReports, { minutes: 1 })
            this.lastFetch = `Última atualização: ${new Date().toLocaleString()}`
            this.$ls.set('cm-embarcador/custom-reports-last-fetch', this.lastFetch, { minutes: 1 })
        })
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
      },
      newCustomReport(customReport) {
        this.currentCustomReport = customReport || EntityProxy.build({ 
          appName: 'cm-embarcador',
          kind: 'cm-embarcador/multa',
          format: 'xlsx',
          schema: [['placa', '']]
        })
        this.showCustomReport = true
      },
      edit(customReport) {
        this.currentCustomReport = customReport
        this.showCustomReport = true
      },
      remove(customReport) {
        if (!confirm('Tem certeza?'))
          return

        this.asyncTemplateDelete(customReport, {
          after: () => {
            this.$notify.add('Relatório excluído com sucesso!')
            this.find(true)
          }
        })
      },
      save() {
        this.asyncTemplateSave(this.currentCustomReport, {
          after: () => {
            this.$notify.add('Relatório salvo com sucesso!')
            this.showCustomReport = false
            this.find(true)
          }
        })
      },
      closeForm() {
        this.showCustomReport = false
      },
    },
    mixins: [ModelMapper],
    name: 'CustomReports'
  }
</script>

<style scoped>
</style>
